import { request } from '@blade/common';
export const getAllTaskList = (data) => request({
    url: '/api/task-management/api/v1/task/list/all',
    method: 'POST',
    data,
});
/**
 *@Description: 请求列表
 */
export const getStatisticsList = (data) => request({
    url: '/api/task-management/api/v1/task/list',
    method: 'POST',
    data,
});
/**
 *@Description: 创建列表
 */
export const createTask = (data) => request({
    url: '/api/task-management/api/v1/task/createTask',
    method: 'POST',
    data,
});
/**
 *@Description: 更新列表
 */
export const updateTask = (data) => request({
    url: '/api/task-management/api/v1/task/updateTask',
    method: 'PUT',
    data,
});
/**
 *@Description: 任务详情
 */
export const taskDetail = (taskId) => request({
    url: `/api/task-management/api/v1/task/${taskId}`,
    method: 'GET',
});
/**
 *@Description: 删除任务
 */
export const deleteTask = (taskId) => request({
    url: `/api/task-management/api/v1/task/${taskId}`,
    method: 'DELETE',
});
/**
 *@Description: 查询设备
 */
export const deviceList = () => request({
    url: `/api/map-management/api/v1/map/device/tree`,
    method: 'GET',
});
/**
 *@Description: 查询区域
 */
export const zoneList = (data) => request({
    url: `/api/map-management/api/v1/map/zone/tree`,
    method: 'POST',
    data,
});
/**
 *@Description: 查询地图信息
 */
const object = {};
export const mapQuery = (data) => request({
    url: `/api/map-management/api/v1/map/query/${data}`,
    method: 'POST',
    data: object,
});
/**
 *@Description: 人体边框
 */
export const lablePerson = (deviceId) => request({
    url: `/api/task-management/api/v1/task/device/lablePerson/deviceIds`,
    method: 'POST',
    data: [deviceId],
});
